<script>
export default {
    methods: {
        hasPermission: function (permissions) {
            var allPermissions = this.$page.props.auth.can
            var hasPermission = false
            permissions.forEach(function (item) {
                if (allPermissions[item]) hasPermission = true
            })
            return hasPermission
        },
        hasRole: function (roles) {
            var allRoles = this.$page.props.auth.is
            var hasRole = false
            roles.forEach(function (item) {
                if (allRoles[item]) hasRole = true
            })
            return hasRole
        },
    },
};
</script>